import Vue from 'vue';
import UUID from 'vue-uuid';
import axios from 'axios';
import VueAxios from 'vue-axios';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueGallery from 'vue-gallery';
import VueLazyload from 'vue-lazyload';
import VueOffline from 'vue-offline';

import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

axios.defaults.baseURL = 'https://imobiliaria.sawup.com.br/api';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';

Vue.use(UUID);
Vue.use(VueAxios, axios);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCYSFkpHgtfdOA9WNnUOVjt2PLlBfC9xvU',
    libraries: 'places',
  },
  installComponents: true,
});
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'ImageError-100.jpg',
  loading: 'Image404-100.jpg',
  attempt: 1,
});
Vue.use(VueOffline);
Vue.component('VGallery', VueGallery);

Vue.config.productionTip = true;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
